import { render, staticRenderFns } from "./DownloadAttachmentUpBox.vue?vue&type=template&id=149e9eb0&"
import script from "./DownloadAttachmentUpBox.vue?vue&type=script&lang=js&"
export * from "./DownloadAttachmentUpBox.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAttachmentUpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports